var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisitors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.5V11.5C8.5 10.837 8.2366 10.2011 7.7678 9.73223C7.2989 9.26339 6.663 9 6 9H3.5C2.837 9 2.2011 9.26339 1.73223 9.73223C1.26339 10.2011 1 10.837 1 11.5V12.5",
    stroke: "#178477",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 6.75C6.13071 6.75 7.25 5.63071 7.25 4.25C7.25 2.86929 6.13071 1.75 4.75 1.75C3.36929 1.75 2.25 2.86929 2.25 4.25C2.25 5.63071 3.36929 6.75 4.75 6.75Z",
    stroke: "#178477",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 4.5V8",
    stroke: "#178477",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.25H9.5",
    stroke: "#178477",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitors);
export default __webpack_public_path__ + "static/media/visitors.055d9e3cd9ec5b77127a419131fdc193.svg";
export { ForwardRef as ReactComponent };